export const getResizeUrl = (url: string, width: number) => {
  url = url.replace('//a.storyblok.com/f/234504', '//assets.picflow.com');
  if (url.includes('//assets.picflow.com')) {
    if (url.includes('.svg')) return url;
    return `${url}/m/${width}x0/filters:quality(90)`;
  }

  const s = url.includes('?') ? '&' : '?';
  return `${url}${s}w=${width}`;
};
